import React, { useEffect, useState } from "react";
import { Box, Button, TextField, CircularProgress } from "@mui/material";
import { ReactComponent as Logo } from "../../Icons/LobyLogo.svg";
import {
  StyledSecondaryServiceTypography,
  SecondaryTypographyDefault,
  ErrorTypography,
} from "../../Theme";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import  { showToast } from "../../CommonComponents/Toaster";

const Login = () => {
  const navigate = useNavigate();
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [errorPassword, setErrorPassword] = useState("");
  const [error, setError] = useState("");

  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(email);
  };

  const handleLogin = async () => {
    setError("");
    if (!validateEmail(email)) {
      setErrorEmail("Please enter a valid email address.");
      return;
    } else {
      setErrorEmail("");
    }

    if (!password) {
      setErrorPassword("Password cannot be empty.");
      return;
    } else {
      setErrorPassword("");
    }
    setLoadingBtn(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}login`,
        { email, password }
      );

      if (response.data?.data?.token?.access_token && response.data?.success) {
        const expiresIn = response.data?.data?.token?.expires_in;
        const expiresAt = Date.now() + expiresIn * 1000; // Calculate expiry timestamp

        // Store tokens and user details
        localStorage.setItem("token", response.data?.data?.token?.access_token);
        localStorage.setItem(
          "refresh",
          response.data?.data?.token?.refresh_token
        );
        localStorage.setItem("expires", expiresAt.toString()); // Store expiry time in ms
        localStorage.setItem(
          "userDetails",
          JSON.stringify(response.data?.data?.user_details)
        );

        // Redirect to sales overview after successful login
        setTimeout(() => {
          navigate("/sales-overview");
          setLoadingBtn(false);
        }, 1000);
        showToast("Login successful", "success");
      }
    } catch (err) {
      if (err?.response?.status === 401) {
        setError(err?.response?.data?.toast);
        showToast(err?.response?.data?.toast, "error");
        console.error("error", err?.response?.data?.toast);
      }
      if (err?.response?.status === 500) {
        showToast("Please try again after some time", "error");
      }
      setLoadingBtn(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/sales-overview");
    }
  }, []);

  return (
    <>
     
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            backgroundColor: "white",
            padding: "40px 24px",
            borderRadius: "12px",
            boxShadow:
              "0px 2px 1px rgba(0, 0, 0, 0.05), 0px 0px 1px rgba(0, 0, 0, 0.25)",
            width: "30%",
          }}
        >
          <Box>
            <Logo style={{ marginBottom: "10px" }} />
            <StyledSecondaryServiceTypography>
              Operation Platform
            </StyledSecondaryServiceTypography>
          </Box>

          {/* Email Input */}
          <Box sx={{ marginTop: "20px" }}>
            <SecondaryTypographyDefault>
              Email Address
            </SecondaryTypographyDefault>
            <TextField
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setErrorEmail("");
                setError("");
              }}
              sx={{
                "& .MuiInputBase-root": { color: "#111927" },
                backgroundColor: "#F9FAFB",
              }}
              InputProps={{ disableUnderline: true }}
              fullWidth
              placeholder="Enter your email"
            />
            <ErrorTypography sx={{ marginTop: "20px" }}>
              {errorEmail}
            </ErrorTypography>
          </Box>

          {/* Password Input */}
          <Box sx={{ marginTop: "20px" }}>
            <SecondaryTypographyDefault>Password</SecondaryTypographyDefault>
            <TextField
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setErrorPassword("");
                setError("");
              }}
              sx={{
                "& .MuiInputBase-root": { color: "#111927" },
                backgroundColor: "#F9FAFB",
              }}
              InputProps={{ disableUnderline: true }}
              fullWidth
              placeholder="Enter your password"
            />
            <ErrorTypography sx={{ marginTop: "20px" }}>
              {errorPassword}
            </ErrorTypography>
          </Box>

          {/* Error Message */}
          {error && (
            <Box sx={{ color: "red", marginTop: "15px", textAlign: "center" }}>
              {error}
            </Box>
          )}

          {/* Login Button */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "25px",
            }}
          >
            <Button
              sx={{
                borderRadius: "8px",
                padding: "10px 18px",
                backgroundColor: "#0E5E84",
                color: "#FFFFFF",
                fontSize: "16px",
                fontWeight: 600,
                "&:hover": { backgroundColor: "#094a63" },
              }}
              fullWidth
              variant="contained"
              onClick={handleLogin}
            >
              {loadingBtn ? (
                <CircularProgress size={25} color="inherit" />
              ) : (
                "Login"
              )}
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Login;
